import React from 'react';
import { cn } from '../../../components/ui/_cn';

// The Finance badge (spec 2026-09-21 §3.3). Tones are the mock's pairs; the
// label is fixed per tone so every table says "In transit" the same way, and
// only the Business Details strip overrides it ("Active", "Complete").
//
// `instant` is the one solid badge: it is a method tag drawn beside a
// status, never a status of its own.
const TONES = {
  paid: { label: 'Paid', cls: 'bg-fin-green-pale text-fin-green' },
  available: { label: 'Available', cls: 'bg-fin-green-pale text-fin-green' },
  pending: { label: 'Pending', cls: 'bg-fin-amber-pale text-fin-amber' },
  'in-transit': { label: 'In transit', cls: 'bg-fin-blue-pale text-fin-blue-deep' },
  failed: { label: 'Failed', cls: 'bg-fin-red-pale text-fin-red' },
  // A payout the bank sent back after it was deposited (mock frame 5f):
  // Stripe's `failed`, but not a payout that never arrived.
  returned: { label: 'Returned', cls: 'bg-fin-red-pale text-fin-red' },
  canceled: { label: 'Canceled', cls: 'bg-fin-neutral-pale text-fin-neutral' },
  instant: { label: 'Instant', cls: 'bg-fin-green text-fin-on-green' },
  // The synthetic leading row on the payout activity list: money that is not
  // yet inside any Stripe payout (spec 2026-09-22 §11). Not a status Stripe
  // ever sends — drawn light-grey/neutral so it never reads as one.
  upcoming: { label: 'Upcoming', cls: 'bg-fin-recess text-fin-ink-2' },
  // An order's money went back to the customer. Neutral, not red: a refund
  // is something the restaurant chose to do, not a failure.
  refunded: { label: 'Refunded', cls: 'bg-fin-neutral-pale text-fin-neutral' },
  'partly-refunded': { label: 'Partly refunded', cls: 'bg-fin-neutral-pale text-fin-neutral' },
};

const SIZES = {
  md: 'text-[11.5px] px-[9px] py-[3px]',
  lg: 'text-[12px] px-2.5 py-1',
};

// No className prop on purpose: `cn` is a plain join, so a second
// `text-[..px]` would win or lose by stylesheet order, not by intent.
const FinBadge = ({ tone, label, dot = false, size = 'md' }) => {
  const meta = TONES[tone] || TONES.canceled;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-md font-semibold tracking-[0.01em]',
        meta.cls,
        SIZES[size] || SIZES.md,
      )}
    >
      {dot ? <span className="h-1.5 w-1.5 rounded-full bg-fin-green-dot" aria-hidden="true" /> : null}
      {label || meta.label}
    </span>
  );
};

export default FinBadge;
